export const parseFileTypeFromLink = (link: string): string => {
    if (link.includes('?')) {
        link = link.substring(0, link.indexOf('?'));
    }

    return link.substring(link.lastIndexOf('.') + 1);
};

export const getFileTypeFromS3Link = parseFileTypeFromLink;
